import { OrdersModel } from '@pukka/api';
import { format } from 'date-fns';

function invoiceReceiptDateTime(date: string | number, string: 'date' | 'time' | 'datetime') {
  const datetime = new Date(date);

  switch (string) {
    case 'date':
      return format(datetime, 'dd MMM yyyy');
    case 'time':
      return format(datetime, 'HH:mm');
    default:
      return format(datetime, 'dd MMM yyyy HH:mm');
  }
}

const compareTaxGratuityName = (
  a: OrdersModel.OrderTax | OrdersModel.OrderGratuity,
  b: OrdersModel.OrderTax | OrdersModel.OrderGratuity,
) => {
  if (a.name < b.name) {
    return -1;
  }

  if (a.name > b.name) {
    return 1;
  }

  return 0;
};

export { invoiceReceiptDateTime, compareTaxGratuityName };
